import { gql } from "@/services/httpAdapter";
import { AwardsFragment, EligibilityFragment } from "./fragments";

export const onCreateSpiffSetup = gql`
	subscription onCreateSpiffSetup($locationId: String, $department: String) {
		onCreateSpiffSetup(locationId: $locationId, department: $department) {
			_id
			locationId
			department
			title
			effectiveDateFrom
			effectiveDateTo
			itemsCount
			items {
				_id
				title
				rolloverCounter
				eligibility {
					...EligibilityFields
				}
				effectiveDateRangeFrom
				effectiveDateRangeTo
				reward
				type
				description
				spiffType
				eligibilityDays
				positions
				requiredDealStatus
				transactionType
				awards {
					...AwardsFields
				}
			}
			createdAt
			createdBy {
				_id
				fullName
			}
			lastModifiedOn
			lastModifiedBy {
				_id
				fullName
			}
		}
	}
	${EligibilityFragment}
	${AwardsFragment}
`;

export const onUpdateSpiffSetup = gql`
	subscription onUpdateSpiffSetup($locationId: String, $department: String, $_id: String) {
		onUpdateSpiffSetup(locationId: $locationId, department: $department, _id: $_id) {
			_id
			locationId
			department
			title
			effectiveDateFrom
			effectiveDateTo
			itemsCount
			items {
				_id
				title
				effectiveDateRangeFrom
				effectiveDateRangeTo
				reward
				type
				description
				createdAt
				spiffType
				eligibilityDays
				positions
				requiredDealStatus
				transactionType
				eligibility {
					...EligibilityFields
				}
				awards {
					...AwardsFields
				}
			}
			createdAt
			createdBy {
				_id
				fullName
			}
			lastModifiedOn
			lastModifiedBy {
				_id
				fullName
			}
		}
	}
	${EligibilityFragment}
	${AwardsFragment}
`;

export const onDeleteSpiffSetup = gql`
	subscription onDeleteSpiffSetup($locationId: String, $department: String, $_id: String) {
		onDeleteSpiffSetup(locationId: $locationId, department: $department, _id: $_id) {
			_id
			locationId
			department
			items {
				_id
				reward
				effectiveDateRangeFrom
				effectiveDateRangeTo
				title
				awardsCount
				type
				createdAt
				spiffType
				eligibilityDays
				positions
				requiredDealStatus
				transactionType
				eligibility {
					...EligibilityFields
				}
				awards {
					...AwardsFields
				}
			}
		}
	}
	${EligibilityFragment}
	${AwardsFragment}
`;

export const onUpdateSpiffItem = gql`
	subscription onUpdateSpiffItem($_id: String) {
		onUpdateSpiffItem(_id: $_id) {
			_id
			title
			effectiveDateFrom
			effectiveDateTo
			itemsCount
			items {
				_id
				title
				effectiveDateRangeFrom
				effectiveDateRangeTo
				reward
				type
				description
				createdBy {
					_id
					fullName
				}
				updatedBy {
					_id
					fullName
				}
				updatedAt
				createdAt
				spiffType
				eligibilityDays
				positions
				requiredDealStatus
				transactionType
				eligibility {
					...EligibilityFields
				}
				awards {
					...AwardsFields
				}
				awardsCount
			}
			createdAt
			createdBy {
				_id
				fullName
			}
			lastModifiedOn
			lastModifiedBy {
				_id
				fullName
			}
		}
	}
	${EligibilityFragment}
	${AwardsFragment}
`;

export const onCreateAward = gql`
	subscription onCreateAward($_id: String) {
		onCreateAward(_id: $_id) {
			_id
			items {
				_id
				awardsCount
				createdAt
				updatedAt
				createdBy {
					_id
					fullName
				}
				updatedBy {
					_id
					fullName
				}
			}
		}
	}
`;

export const onUpdateAward = gql`
	subscription onUpdateAward($_id: String) {
		onUpdateAward(_id: $_id) {
			_id
			items {
				_id
				title
				reward
				createdAt
				createdBy {
					fullName
				}
				updatedAt
				updatedBy {
					_id
					fullName
				}
			}
		}
	}
`;

export const onDeleteAward = gql`
	subscription onDeleteAward($_id: String) {
		onDeleteAward(_id: $_id) {
			_id
			items {
				_id
				awardsCount
				createdAt
				updatedAt
				createdBy {
					_id
					fullName
				}
				updatedBy {
					_id
					fullName
				}
			}
		}
	}
`;

export const onCreateSpiffItem = gql`
	subscription onCreateSpiffItem($_id: String) {
		onCreateSpiffItem(_id: $_id) {
			_id
			title
			effectiveDateFrom
			effectiveDateTo
			itemsCount
			items {
				_id
				title
				effectiveDateRangeFrom
				effectiveDateRangeTo
				reward
				type
				description
				createdAt
				spiffType
				eligibilityDays
				positions
				requiredDealStatus
				transactionType
				eligibility {
					...EligibilityFields
				}
				awards {
					...AwardsFields
				}
			}
			createdAt
			createdBy {
				_id
				fullName
			}
			lastModifiedOn
			lastModifiedBy {
				_id
				fullName
			}
		}
	}
	${EligibilityFragment}
	${AwardsFragment}
`;

export const onDeleteSpiffItems = gql`
	subscription onDeleteSpiffItems($_id: String) {
		onDeleteSpiffItems(_id: $_id) {
			_id
			items {
				_id
				awardsCount
			}
		}
	}
`;

export const onCreateSpiffItemDepartment = gql`
	subscription onCreateSpiffItemDepartment($locationId: String, $department: String) {
		onCreateSpiffItemDepartment(locationId: $locationId, department: $department) {
			_id
			title
			items {
				_id
				title
			}
			commissionCycle {
				_id
				title
				startDate
			}
		}
	}
`;

export const onUpdateSpiffItemDepartment = gql`
	subscription onUpdateSpiffItemDepartment($locationId: String, $department: String) {
		onUpdateSpiffItemDepartment(locationId: $locationId, department: $department) {
			_id
			title
			effectiveDateFrom
			effectiveDateTo
			items {
				_id
				title
				effectiveDateRangeFrom
				effectiveDateRangeTo
				reward
				type
				createdBy {
					_id
					fullName
				}
				createdAt
				spiffType
				eligibilityDays
				positions
				requiredDealStatus
				transactionType
				eligibility {
					...EligibilityFields
				}
				awardsCount
			}
			commissionCycle {
				_id
				title
				startDate
			}
		}
	}
	${EligibilityFragment}
`;

export const onDeleteSpiffItemsDepartment = gql`
	subscription onDeleteSpiffItemsDepartment($locationId: String, $department: String) {
		onDeleteSpiffItemsDepartment(locationId: $locationId, department: $department) {
			_id
			title
			items {
				_id
				title
			}
			commissionCycle {
				_id
				title
				startDate
			}
		}
	}
`;
